/**
 * @fileoverview
 * @author Taketoshi Aono
 */

export class Rethrower {
  /* eslint no-useless-constructor:0 */
  /* eslint no-empty-function:0 */
  constructor(public error: Error) {}
  /* eslint no-empty-function:1 */
  /* eslint no-useless-constructor:1 */

  static async try<T>(proc: () => T): Promise<T> {
    try {
      return await proc();
    } catch (error: any) {
      throw new Rethrower(error);
    }
  }
}
